var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ButtonSecondary, IconInstagram, IconTwitterX, cssColorValue, screenSmMax, cssSpacing, IconTiktok, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { useS4AMastheadContext } from '../S4AMastheadProvider';
import { trackCat } from './constants';
import { LinkedInLogo } from './icons/LinkedInLogo';
var Column = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 0px;\n  gap: ", ";\n  flex: none;\n  order: 4;\n  align-self: stretch;\n  flex-grow: 1;\n  width: calc(24% - 16px);\n  @media (max-width: ", ") {\n    order: 2;\n    align-items: flex-start;\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 0px;\n  gap: ", ";\n  flex: none;\n  order: 4;\n  align-self: stretch;\n  flex-grow: 1;\n  width: calc(24% - 16px);\n  @media (max-width: ", ") {\n    order: 2;\n    align-items: flex-start;\n    width: 100%;\n  }\n"])), cssSpacing('base'), screenSmMax);
var SocialContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding: 0px;\n  gap: ", ";\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding: 0px;\n  gap: ", ";\n  flex-wrap: wrap;\n"])), cssSpacing('base'));
var StyledButtonSecondary = styled(ButtonSecondary)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", " !important;\n\n  &:hover {\n    border-color: ", ";\n  }\n"], ["\n  color: ", " !important;\n\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (props) { var _a, _b; return (_b = (_a = props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); }, function (props) { var _a, _b; return (_b = (_a = props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); });
var getSocialIcon = function (platform) {
    switch (platform.toLowerCase()) {
        case 'instagram':
            return IconInstagram;
        case 'twitterx':
            return IconTwitterX;
        case 'tiktok':
            return IconTiktok;
        case 'linkedin':
            return LinkedInLogo;
        default:
            return null;
    }
};
export var FooterSocial = function (_a) {
    var colors = _a.colors, footerEntry = _a.footerEntry;
    var InteractiveElement = useS4AMastheadContext().InteractiveElement;
    var socialUrlsEntry = footerEntry.fields.socialUrls;
    var socialUrls = socialUrlsEntry === null || socialUrlsEntry === void 0 ? void 0 : socialUrlsEntry.fields;
    var socialLinks = [
        {
            href: socialUrls === null || socialUrls === void 0 ? void 0 : socialUrls.instagram,
            title: 'Instagram',
            trackingLabel: 'Social - Instagram'
        },
        {
            href: socialUrls === null || socialUrls === void 0 ? void 0 : socialUrls.twitterX,
            title: 'TwitterX',
            trackingLabel: 'Social - TwitterX'
        },
        {
            href: socialUrls === null || socialUrls === void 0 ? void 0 : socialUrls.linkedIn,
            title: 'LinkedIn',
            trackingLabel: 'Social - LinkedIn'
        },
        {
            href: socialUrls === null || socialUrls === void 0 ? void 0 : socialUrls.tikTok,
            title: 'TikTok',
            trackingLabel: 'Social - TikTok'
        },
    ].filter(function (link) { return link.href; });
    return (React.createElement(Column, null,
        React.createElement(SocialContainer, null, socialLinks.map(function (link, index) {
            var IconComponent = getSocialIcon(link.title);
            if (!IconComponent || !link.href)
                return null;
            return (React.createElement(InteractiveElement, { key: "".concat(link.title, "-").concat(index), customComponent: StyledButtonSecondary, "data-testid": "footer-".concat(link.title.toLowerCase()), target: "_blank", href: link.href, iconOnly: IconComponent, "aria-label": link.title, colors: colors, trackingCategory: trackCat, trackingLabel: link.trackingLabel }));
        }))));
};
var templateObject_1, templateObject_2, templateObject_3;
